export { ConsentProvider, useConsent } from './use-consent'
export {
  CONSENT_COOKIE,
  CONSENT_EVENT,
  CONSENT_VERSION,
  DEFAULT_DENIED,
  ALL_ACCEPTED,
  PRE_DECISION_DEFAULTS,
  type ConsentCategories,
  type StoredConsent,
} from './types'
export { setDefaultGtagConsent, updateGtagConsent } from './gtag'
